module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M6 6h2v12H6z\"></path><path d=\"M9.5 12l8.5 6V6z\"></path></svg>"